<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <el-form ref="formValidate" :model="model" :rules="rules" label-width="120px">
            <el-form-item label="设备类型：" prop="device_type">
                <el-select clearable v-model="model.device_type" placeholder="请选择" :disabled="model.id" style="width: 200px" @change="typeChange">
                    <el-option v-for="item in enuObj('device_type3')" :key="'device_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="出厂编号：" prop="device_id">
                <el-select v-model="model.device_id" placeholder="请选择" :disabled="model.id" clearable filterable style="width: 200px">
                    <el-option v-for="item in deviceList" :key="item.id"  :label="item.factory_code" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="检测时间：" prop="check_date">
                <el-date-picker v-model="model.check_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <el-input type="textarea" :rows="4" v-model="model.remark"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handleSubmit" size="medium">确 定</el-button>
            <el-button @click="closeDialog" size="medium">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelById, saveModel } from '@/api/common'
import { getAllDeviceCheckList, getFlowMeterList } from '@/api/deviceuser'

export default {
    name: 'deviceTestLogEdit',
    mixins: [editutil],
    data() {
        return {
            model: {
                device_type: '',
                device_id: '',
                device_code: '',
                check_date: '',
                remark: '',
                creator_id: '',
                creator_name: '',
                create_time: '',
                update_id: '',
                update_name: '',
                update_time: '',
            },
            getObj:{
                url:'/api/admin/devicetestlog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['device_type3'],
            rules: {
                device_type: [
                    {required: true, message: '设备类型不能为空', trigger: 'blur'}
                ],
                device_id: [
                    {required: true, message: '设备编号不能为空', trigger: 'blur'}
                ],
                check_date: [
                    {required: true, message: '检测日期不能为空', trigger: 'blur'}
                ],
            },
            deviceList: [],
        };
    },
    methods: {
        //保存方法
        typeChange(e){
            if(e == '1'){
                getAllDeviceCheckList().then(res=>{
                    if(res.code ==1){
                        this.deviceList = res.data
                    }
                })
            }else if(e =='2'){
                getFlowMeterList(1).then(res=>{
                    if(res.code ==1){
                        this.deviceList = res.data
                    }
                })
            }else if(e =='3'){
                getFlowMeterList(2).then(res=>{
                    if(res.code ==1){
                        this.deviceList = res.data
                    }
                })
            }else if(e =='4'){
                getFlowMeterList(3).then(res=>{
                    if(res.code ==1){
                        this.deviceList = res.data
                    }
                })
            }else if(e =='5'){
                getFlowMeterList(4).then(res=>{
                    if(res.code ==1){
                        this.deviceList = res.data
                    }
                })
            }
        },
        handleSubmit() {
            this.$refs[this.form_name].validate((valid) => {
                if (valid) {
                    this.formatModel();
                    let config = {
                        url:'/api/admin/devicetestlog/save'
                    }
                    config["data"] = this.model;
                    saveModel(config).then(res=>{
                        if(res.code===1){
                            this.$msgs("保存成功！");
                            this.$emit("on-save-ok",{});
                        }else{
                            this.$msg(res.msg)
                        }
                    }).catch();
                }
            })
        },
        formateData(){
            this.model.device_type = this.model.device_type+""
        },
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data;
                        if (this.exits_p_name != '') {
                            this.old_check = this.model[this.exits_p_name];
                        }
                        this.formateData();
                        this.typeChange(this.model.device_type)
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
    }
};
</script>